import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { colors } from '@sensei/pi-component';

const useLoadingStyles = makeStyles((theme: Theme) =>
    createStyles({
        grid: {
            backgroundColor: colors.SAND,
        },
    }),
);

export default useLoadingStyles;
